<script lang="ts">
	export let name = "";
	export let inlineMode = false;

</script>

<div class="container" class:inlineMode>
	<span class="name" class:noneDisplay={name === ''}> {name} </span>
	<div class="values">
		<slot />
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	//MobileFirst
	.container {
		display: flex;
		flex-direction: column;
		gap: 10px;

		&.inlineMode {
			height: auto;

			.values {
				height: auto;
			}
		}

		.name {
			font-size: 1rem;
			color: #6d6f76;

			&.noneDisplay {
				display: none;
			}
		}

		.values {
			display: flex;
			flex-grow: 1;
			gap: 10px;
			align-items: center;
		}
	}

	//Desktop
	@include DesktopSize {
		.container {
			flex-direction: row;
			align-items: center;
			gap: 36px;

			&.inlineMode {
				height: auto;

				.values {
					height: auto;
				}
			}

			.name {
				flex-basis: 150px;
				min-width: 150px;
				max-width: 150px;
				font-size: 1.25rem;

				&.noneDisplay {
					display: block;
				}
			}

			.values {
				display: flex;
				flex-grow: 1;
				height: 40px;
			}
		}
	}

</style>
